import { db } from '../config/firebaseApp';

export default db;
